import React from 'react'

import FeedItem from 'js/components/FeedItem/FeedItem'
import FeedItemContent from 'js/components/FeedItem/FeedItemContent'

const Card = ({ 'data-feed': dataFeed, entity }) => {
    // A magazine issue has no title, so we need to add the container title and issue number
    const alteredEntity = {
        ...entity,
        title: `${entity.container?.title} ${entity.issueNumber}`,
    }
    return (
        <FeedItem data-feed={dataFeed}>
            <FeedItemContent entity={alteredEntity} />
        </FeedItem>
    )
}

export default Card
